/**
 * @Author: longZhi
 * @Date: 2025-09-29 15:30
 * @LastEditors: longZhi
 * @Description: 屏幕共享弹窗
 */
<template>
  <!-- <div class="screen-sharing-dialog"> -->
    <div class="dialog-box" v-if="showPopup">
      <div class="dialog-left">
        <img class="dialog-left-avatar" :src="screenSharingUserAvatar ? screenSharingUserAvatar : user_default_avatar" alt="" />
        <div>
          <div class="dialog-left-name">{{ screenSharingUserName }}</div>
          <div class="dialog-left-tip">邀请对您进行远程教学</div>
        </div>
      </div>
      <div class="dialog-right">
        <img :src="closeIcon" alt="" @click.stop.prevent="handleCancel" />
        <img :src="agreeIcon" alt="" @click.stop.prevent="handleAgree" />
      </div>
    </div>
    <!-- 用于播放屏幕共享流 -->
    <div v-if="showScreenShare" id="trtc_share_screen" class="screen_share_box" />
  <!-- </div> -->
</template>

<script setup>
import { ref, defineProps } from 'vue';
import { getScreenShareSdkAppId, getScreenShareUserSig } from '@/assets/js/request/api';
import TRTCScreenShare from "@/utils/trtc";
import useUsersStore from '@/stores/user';
import user_default_avatar from "@/assets/images/my/user_default_avatar.png";
import agreeIcon from "@/assets/images/home/agree.png";
import closeIcon from "@/assets/images/home/close.png";
const usersStore = useUsersStore();
const trtcScreenShare = new TRTCScreenShare(); // 创建trtc实例

const props = defineProps({
  showPopup: {
    type: Boolean,
    default: false
  },
  screenSharingUserName: {
    type: String,
    default: ''
  },
  screenSharingUserAvatar: {
    type: String,
    default: ''
  }
});
const showScreenShare = ref(false);

// 同意
const handleAgree = async () => {
  const userId = usersStore.newUserInfo?.userId || '';
  // const userName = usersStore.newUserInfo?.nickName || '';
  const requestList = [
    getScreenShareSdkAppId(),
    getScreenShareUserSig(),
  ];
  const res = await Promise.all(requestList);
  if (res[0]?.code !== 200 || res[1]?.code !== 200 || !res[0]?.data || !res[1]?.msg) {
    return;
  };
  showScreenShare.value = true;
  await trtcScreenShare.initTRTC({
    sdkAppId: res[0].data,
    userId: userId,
    userSig: res[1].msg,
    mode: 'rtc',
    useStringRoomId: true,
  });
  await trtcScreenShare.streamAdded({
    roomId: usersStore.screenSharingRoomId,
    elementId: "trtc_share"
  });
};
// 取消
const handleCancel = () => {
  usersStore.setScreenSharingPopup(false);
};
</script>

<style lang="scss" scoped>
// .screen-sharing-dialog {
//   width: 100%;
//   position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 999;
  .dialog-box {
    width: calc(100% - 14px);
    padding: 15px;
    background: #1F1F1F;
    border-radius: 12px;
    position: fixed;
    top: 50px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .dialog-left {
      display: flex;
      align-items: center;
      .dialog-left-avatar {
        width: 58px;
        height: 58px;
        border-radius: 50%;
        display: block;
        margin-right: 12px;
      }
      .dialog-left-name {
        width: 160px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        font-style: normal;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .dialog-left-tip {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #838383;
        font-style: normal;
        margin-top: 8px;
      }
    }
    .dialog-right {
      display: flex;
      align-items: center;
      img {
        width: 38px;
        height: 38px;
        display: block;
      }
      img:first-child {
        margin-right: 12px;
      }
    }
  }
  .screen_share_box {
    width: 100%;
    height: 40%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
  }
// }
</style>
<style lang="scss">
.van-notice-bar__content {
  width: 100%;
}
</style>
